// src/data/type-chart.ts

/**
 * 洛克王国：世界 系别相性表
 * 数据来源：用户提供的官方系别相性一览表图片
 * 表格数值：2=克制(绿↑)，0.5=抵抗(红↓)，未列出=1(无关系)
 */
export const TYPE_CHART: Record<string, Record<string, number>> = {
  普通: { 幽: 0.5, 机械: 0.5, 地: 0.5 },
  草: { 火: 0.5, 龙: 0.5, 水: 2, 光: 2, 地: 2, 毒: 0.5, 翼: 0.5, 虫: 0.5, 机械: 0.5 },
  火: { 草: 2, 冰: 2, 水: 0.5, 地: 0.5,  龙: 0.5, 虫: 2, 机械: 2, },
  水: { 火: 2, 地: 2, 机械: 2, 龙: 0.5,  冰: 0.5, 草:0.5 },
  光: { 草: 0.5,冰:0.5, 幽: 2,恶:2 },
  地: { 火: 2, 电: 2, 毒: 2, 冰: 2,草: 0.5, 武:0.5},
  冰: { 草: 2, 火: 0.5,  地: 2, 冰: 0.5, 龙: 2, 翼: 2,机械:0.5},
  龙: { 龙: 2, 机械: 0.5 },
  电: { 草: 0.5, 水: 2, 地: 0.5, 翼: 2, 龙: 0.5,电:0.5},
  毒: { 草: 2, 地: 0.5, 毒: 0.5, 幽: 0.5, 机械: 0.5, 萌: 2 },
  虫: { 草: 2, 幻:2, 火: 0.5, 毒: 0.5, 武: 0.5, 翼: 0.5, 萌: 0.5, 幽: 0.5, 机械: 0.5, 恶: 2 },
  武: { 普通: 2, 冰: 2, 地: 2, 机械: 2, 恶:2, 毒: 0.5, 虫:0.5,翼: 0.5, 萌: 0.5, 幽: 0.5, 幻: 0.5 },
  翼: { 草: 2, 武: 2, 虫: 2, 电: 0.5, 机械: 0.5, 地: 0.5, 龙: 0.5},
  萌: { 武: 2, 龙: 2, 恶: 2, 火: 0.5, 毒: 0.5, 机械: 0.5 },
  幽: { 光: 0.5, 幽: 2, 幻: 2, 普通:0.5, 恶: 0.5 },
  恶: { 毒: 2, 幽: 2, 武: 0.5, 恶: 0.5, 光:0.5, 萌: 2 },
  机械: { 火: 0.5, 水: 0.5, 冰: 2, 萌: 2, 地:2, 机械: 0.5, 电: 0.5 },
  幻: { 毒: 2, 武: 2, 光:0.5, 幻: 0.5, 机械: 0.5 },
};

/**
 * 计算技能系别对防守方（可能双系别）的克制倍率
 * 严格遵循图片规则：
 * 单系弱点：×2
 * 单系抗性：×0.5
 * 双重弱点：×3（加法叠加：2 + 1 = 3）
 * 双重抗性：×0.25（乘法叠加：0.5 * 0.5 = 0.25）
 * 一克一抗：×1
 */
export function getTypeEffectiveness(
  attackType: string,
  defenderTypes: string[],
): number {
  let weaknessCount = 0;
  let resistanceCount = 0;

  defenderTypes.forEach((defType) => {
    const row = TYPE_CHART[attackType];
    const multiplier = row?.[defType];
    if (multiplier === 2) weaknessCount++;
    else if (multiplier === 0.5) resistanceCount++;
  });

  // 1. 双重弱点：×3
  if (weaknessCount === 2 && resistanceCount === 0) return 3;
  
  // 2. 双重抗性：×0.25
  if (resistanceCount === 2 && weaknessCount === 0) return 0.25;
  
  // 3. 单系弱点：×2
  if (weaknessCount === 1 && resistanceCount === 0) return 2;
  
  // 4. 单系抗性：×0.5
  if (resistanceCount === 1 && weaknessCount === 0) return 0.5;

  // 5. 一克一抗 或 无关系：×1
  return 1;
}